<!-- template-tree-viewer.component.html -->
<div class="tree-viewer">
    @for (node of nodes; track node.name) {
        <div class="tree-node">
            <div class="node-row">
                @if (node.children && node.children.length > 0) {
                    <button mat-icon-button type="button" (click)="toggleExpand(node)">
                        <mat-icon>{{ node.expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
                    </button>
                } @else {
                    <mat-icon style="color: var(--app-outline); margin-right: 4px; width:24px">
                        fiber_manual_record
                    </mat-icon>
                }

                <span class="node-name">{{ node.name }}</span>
                <div class="node-chips-column">
                    @if (node.value != null) {
                        <div>
                            <span>
                                {{ node.value }}
                            </span>
                        </div>
                    }
                </div>

                <!-- Chips & constraints in a separate, vertical column -->
                @if (!(node.children && node.children.length > 0)) {
                    <div class="node-chips-column">
                        <mat-chip-list>
                            <mat-chip color="primary" selected class="small-chip">
                                {{ getTypeLabel(node.type) }}
                            </mat-chip>
                        </mat-chip-list>

                        @if (node.type === 'number' && (node.min != null || node.max != null)) {
                            <span class="constraints">
                                @if (node.min != null) {
                                    <span>Min: {{ node.min }}</span>
                                }
                                @if (node.max != null) {
                                    <span>&nbsp;Max: {{ node.max }}</span>
                                }
                            </span>
                        }
                    </div>
                } @else {
                    <!-- Group chip for nodes with children, also in its own column -->
                    <div class="node-chips-column">
                        <!-- Group chip could go here -->
                    </div>
                }
            </div>

            @if (node.expanded && node.children && node.children.length > 0) {
                <div class="node-children">
                    <app-certification-template-tree-viewer [nodes]="node.children"></app-certification-template-tree-viewer>
                </div>
            }
        </div>
    }
</div>